export enum CaseReturnRequestType {
  Label = 'Label',
  Pickup = 'Pickup',
}
